module.exports = __webpack_public_path__ + "media/images/ticket/ticket_order_limit-2e5f06b83fd1f97825a7a7d987e5548a.png";